module.exports = __webpack_public_path__ + "img/yipin.336b4bdd.png";